export const getPriceMultipleTvaChecked = tvaArray => {
  return Number.parseFloat(
    tvaArray.reduce((acc, item) => {
      return acc + item.amount_tva + Number(item.withoutTva);
    }, 0)
  ).toFixed(2);
};

export const computeSumTvasAmount = (tvas = []) => {
  if (!Array.isArray(tvas)) return 0;
  return tvas.reduce((acc, cur) => (cur.percentage === 0 ? acc : parseFloat(cur.amount_tva) + acc), 0);
};

export const computeAmountFromTva = ({ amount_tva, percentage }) => {
  if (percentage === 0 || amount_tva === "") return 0;
  return parseFloat(amount_tva) * (1 + 100 / percentage);
};

export const computeSumTvasWithout0Percentage = (tvas = []) => {
  if (!Array.isArray(tvas)) return 0;
  return tvas.reduce((acc, cur) => (cur.percentage === 0 ? acc : parseFloat(cur.amount) + acc), 0);
};



// WEBPACK FOOTER //
// src/modules/presence/components/Tva.utils.js